import styled from 'styled-components';
import searchGlass from '../icons/search-magnifying-glass-svgrepo-com.svg';

export const SearchbarStyled = styled.header`
  top: 0;
  left: 0;
  position: sticky;
  display: flex;
  z-index: 1100;
  justify-content: center;
  align-items: center;
  min-height: 64px;
  padding-right: 24px;
  padding-left: 24px;
  padding-top: 12px;
  padding-bottom: 12px;
  color: #fff;
  background-color: #3f51b5;
  box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2),
    0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12);

  & > form {
    display: flex;
    align-items: center;
    width: 100%;
    max-width: 600px;
    background-color: #fff;
    border-radius: 3px;
    overflow: hidden;

    & > button {
      display: inline-block;
      width: 48px;
      height: 48px;
      border: 0;
      background-image: url(${searchGlass});
      background-size: 50%;
      background-repeat: no-repeat;
      background-position: center;
      opacity: 0.6;
      transition: opacity 250ms cubic-bezier(0.4, 0, 0.2, 1);
      cursor: pointer;
      outline: none;

      &:hover {
        opacity: 1;
      }

      & > span {
        position: absolute;
        width: 1px;
        height: 1px;
        padding: 0;
        overflow: hidden;
        clip: rect(0, 0, 0, 0);
        white-space: nowrap;
        clip-path: inset(50%);
        border: 0;
      }
    }

    & > input {
      display: inline-block;
      width: 100%;
      font: inherit;
      font-size: 18px;
      border: none;
      outline: none;
      padding-left: 10px;
      padding-right: 10px;

      &::placeholder {
        font: inherit;
        font-size: 18px;
      }
    }
  }
`;
